import { useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import Panel from 'components/atoms/GefMui/Panel/Panel';
import PaperWithToolbar from 'components/atoms/GefMui/PaperWithToolbar';
import PAGES from 'constants/pages';
import { subheaders } from 'features/common/Subheader/constants';
import { useRenderSubheaderTitle } from 'features/common/Subheader/hooks';
import { getContextUser } from 'features/views/userContext/selectors';

import CommunicationInfo from './components/CommunicationInfo';
import CommunicationOverview from './components/CommunicationOverview';
import CommunicationOverviewTable from './components/CommunicationOverviewTable';
import Note from './components/Note';
import ServicesList from './components/ServicesList';
import Toolbar from './components/Toolbar';

export const ContactHistory = () => {
	const contextUser = useSelector(getContextUser);
	const subheaderTitle = useRenderSubheaderTitle({
		contextUser,
		pageTitle: getLabelMessage('contactHistory:communicationOverviewHeader'),
	});

	return (
		<Panel screenId={PAGES.contactHistory.id} screenName={PAGES.contactHistory.name}>
			<PaperWithToolbar
				subheaderTitle={subheaderTitle}
				subTitle={getLabelMessage('contactHistory:contactHistoryTableRecords1YearOldOnly')}
				toggledElement={<CommunicationOverview />}
				toolbar={<Toolbar />}
				collapsibleProps={{ id: subheaders.contactHistory, initiallyOpen: true }}
			>
				<CommunicationOverviewTable />
			</PaperWithToolbar>
			<CommunicationInfo />
			<ServicesList />
			<Note />
		</Panel>
	);
};

export default ContactHistory;
